import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'
import Lazyload from 'react-lazy-load'
import {Trans, useTranslation, useI18next} from 'gatsby-plugin-react-i18next';
import { useLocation } from '@reach/router';

const HolisticWellnessProgram = () => {
    const location = useLocation();
    const { pathname } = location;
    const { t } = useTranslation();
    return (
    <>
        <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 soln-hero hwp-1">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h1 className="font-weight-semibold hero-heading text-center">
                        <Trans>Embracing Total Wellbeing</Trans>
                    </h1>
                    <p className="hero-para font-weight-normal text-center no-br">
                        <Trans>Integrate physical, mental and emotional wellness for a <br/>comprehensive employee well-being approach.</Trans>
                    </p>
                    <div className="pl-0 pr-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pb-0 vfitsoln">
            <div className="feat_box sect-white-col-2 shadow active_challenge">
                <div className="d-flex m-d-block container custom_container p0 justify-content-between align-items-center">
                    <div className="col-12 col-md-6 p-0">
                        <div className="col-12 p-0">
                            <h2 className='font-weight-semibold py-2 section-heading mb-4 no-br green-text'><Trans>Want a one-stop <br/>solution that <br/>covers all facets of <span>wellness?</span></Trans></h2>
                            <p className='section-para font-weight-light no-br'><Trans>Our Holistic Program offers an all-inclusive platform, <br/>eliminating the need for multiple tools or solutions.</Trans></p>
                        </div>
                    </div>
                    <div className='cta-img'>
                        <div className='d-flex justify-content-center'>
                            <img loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/v1703070502/VantageFit/2023/Holistic_Wellness-painpoint.webp" alt="Want a one-stop solution that covers all facets of wellness?" width="700" height=""/>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="">
                <h2 className="section-heading section-heading-top font-weight-semibold text-center no-br"><Trans>Take a Mindful Moment into the <br/>Holistic Wellness Program.</Trans></h2>
                <div className="">
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Diverse Wellness Challenges</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>From step challenges to yoga sessions, cater to all fitness levels and interests.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Offer diverse challenges, from step competitions to yoga sessions.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Cater to a range of fitness levels and interests.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Provide options that accommodate different preferences and abilities.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1698907356/VantageFit/2023/Holistic_Wellness-Diverse_Wellness_Challenges.webp`)} loading='lazy' alt="Diverse Wellness Challenges" width="432" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Mental Health Support</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Guided meditations, expert talks and resources to nurture the mind.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Access guided meditations, expert talks, and mental health materials.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Provide resources for mental well-being through professional insights.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Foster mental wellness with a range of guided meditations and expert talks.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1698907357/VantageFit/2023/Holistic_Wellness-Mental_Health_Support.webp`)} loading='lazy' alt="Mental Health Support" width="546" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Nutrition and Calorie Tracking</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Promote a balanced diet and healthy eating habits among employees.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Encourage healthy eating habits through nutrition tracking.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Provide a tool for employees to track and manage their calorie intake.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Promote a balanced diet for overall health and well-being.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703070502/VantageFit/2023/Holistic_Wellness-Nutrition_and_Calorie_Tracking.webp`)} loading='lazy' alt="Nutrition and Calorie Tracking" width="525" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Rewards and Recognition</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Celebrate milestones and achievements, keeping motivation high.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Recognize and celebrate achievements to boost motivation.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Sustain high motivation by acknowledging milestones regularly.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Keep spirits high with consistent rewards for accomplishments.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703072846/VantageFit/2023/Holistic_Wellness-Rewards_and_Recognition.webp`)} loading='lazy' alt="Rewards and Recognition" width="482" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="gray-gradient-bg section-pdn-1">
            <div className="container custom_container mx-auto relative">
                <div className="px-5">
                    <h2 className="section-heading text-center pt-0">
                    <Trans>Real people, real results</Trans>
                    </h2>
                    <p className="col-12 sub-para text-center f-400 mt-0 mb-5 pb-5">
                    <Trans>Vantage Fit speaks for itself, but our
                        customer reviews speak even louder.</Trans>
                    </p>
                    {/* <div className="col-lg-12 testimonialcarousel mb-0 p-5">
                        <div className="testi_profile">
                            <div className="testi_profile_image"><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1700204241/VantageFit/2023/Jayson_Ho.webp" alt="Jayson Ho" className="max-w lozad" width="218" height="218" loading="lazy"/></div>
                            <div className="testi_profile_name p-4">
                                <h3 className="font-weight-bold text-center text-lg-left text-white mb-0">Jayson Ho</h3>
                                <p className="font-weight-light text-center text-lg-left text-white mb-0">Ruby Digital</p>
                            </div>
                        </div>
                        <div className="d-flex flex-column flex-lg-row justify-content-around align-items-center ">
                            <div className="col-12 col-md-11 d-flex flex-column">
                                <p className="section-para text-center text-lg-left mb-0">Overall we really love how fun and motivating the app has been for us all here at Ruby Digital. It sure brings out a person's competitive nature in a healthy manner.</p>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-lg-12 testimonialcarousel d-none d-md-flex mb-0 p-5">
                        <div className="testi_profile">
                            <div className="testi_profile_image"><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1700137313/VantageFit/2023/Jayson_Ho.webp" alt="Jayson Ho" className="max-w lozad" width="218" height="218" loading="lazy"/></div>
                            <div className="testi_profile_name p-4">
                                <h3 className="font-weight-bold text-center text-lg-left text-white mb-0">Jayson Ho</h3>
                                <p className="font-weight-light text-center text-lg-left text-white mb-0"><Trans>Ruby Digital</Trans></p>
                            </div>
                        </div>
                        <div className="d-flex flex-column flex-lg-row justify-content-around align-items-center ">
                            <div className="col-12 col-md-11 d-flex flex-column">
                                <p className="section-para text-center text-lg-left mb-0"><Trans>Overall we really love how fun and motivating the app has been for us all here at Ruby Digital. It sure brings out a person's competitive nature in a healthy manner.</Trans></p>
                            </div>
                        </div>
                    </div>
                    <div className="d-md-none d-block p-3" style={{ background: 'white', boxShadow: '1px 0px 20px rgba(0,0,0,0.3)', borderRadius: '25px' }}>
                        <div className="p-2" style={{ background: '#1d2227', borderRadius: '40px', display: 'grid', justifyContent: 'center' }}>
                            <img style={{ marginLeft: '0.5rem !important', marginTop: '0.5rem', marginBottom: '1rem' }} src="https://res.cloudinary.com/vantagecircle/image/upload/v1700218240/VantageFit/2023/Jayson_Ho.webp" alt="Jayson Ho" className="mx-auto" width="218" height="218" loading="lazy"/>
                            <h3 className="font-weight-bold text-center text-white mb-0">Jayson Ho</h3>
                            <p className="font-weight-light text-center text-white my-3"><Trans>Ruby Digital</Trans></p>
                        </div>
                        <p className="section-para text-center text-lg-left my-4"><Trans>Overall we really love how fun and motivating the app has been for us all here at Ruby Digital. It sure brings out a person's competitive nature in a healthy manner.</Trans></p>

                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative section-pdn-1 pl-0 pr-0 faq-wrapper">
            <div className="logo-container">
                <h2 className="section-heading mb-5 no-br clr49 font-weight-bold">FAQ</h2>
                <div id="accordion" className="">
                    <Card>
                        <Button id="faq1">
                        <Trans>How do we ensure employees engage in all aspects of the program?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq1">
                            <CardBody>
                            <Trans>Vantage Fit enables the creation of challenges tailored to your needs and objectives. This customization allows for the inclusion of activities within the challenges that align with users' specific requirements, ensuring that employees actively participate in all aspects of the program.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                    <Card>
                        <Button id="faq2">
                        <Trans>Can we customize the holistic program to better fit our organization's needs?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq2">
                            <CardBody>
                            <Trans>Yes, we can customize the holistic program to better fit the organization's needs.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                    <Card>
                        <Button id="faq3">
                        <Trans>Does Vantage Fit offer a diverse range of categories for physical well-being?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq3">
                            <CardBody>
                            <Trans>Vantage Fit offers a variety of physical well-being activities, encompassing outdoor pursuits, workout regimens, activity logging in sports, well-being, cardiovascular exercises, and more.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                </div>
            </div>
        </section>

        <section className="mhc-btm ctabtm multi-activity hero-bg position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center no-br">
                    <Trans>Embrace a Comprehensive Wellness <br/>Vision with Vantage Fit!</Trans>
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5">
                    <Trans>Prioritize every facet of employee well-being.</Trans>
                    </p>
                    <div className="pl-0 pr-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </>
  )
}

export default HolisticWellnessProgram
